import { HttpParams } from '@angular/common/http';
import * as UIModels from '@shared-models/index';

export class BaseServiceClass {
    constructor() {
    }

    transformGetRequest(data: UIModels.CE.KeyValue): HttpParams {
        try {
            Object.keys(data).forEach((item: string) => data[item] = data[item].toString());
        } catch (e) {}

        return data as HttpParams;
    }

    // TODO: use strict types if this function will be used in future
    transformUploadFileRequest(data: any): any {
        const fd = new FormData();

        for (const key in data) {
            if (key !== 'files') {
                fd.append(key, data[key]);
            }
        }

        for (let i = 0; i < data.files.length; i++) {
            fd.append('file' + i, data.files[i]);
        }

        return fd;
    }
}
